import { Subcollection } from "@comparaonline/ui-checkout-cico";
import { DocumentSnapshot, FirestoreError } from "@firebase/firestore-types";

import { injectDataOwner } from "../helpers";
import { FunnelName, FunnelCollectionName } from "../constants";
import { FirebaseClient } from "../types";

const getCheckoutDocRef = (quoteId: string, firebase: FirebaseClient) =>
  firebase.db
    .collection(FunnelName.Cico)
    .doc(quoteId)
    .collection(FunnelCollectionName.Checkout)
    .doc(quoteId);

export const onCheckoutSnapshot = (
  quoteId: string,
  firebase: FirebaseClient,
  onSnapshot: (documentSnapshot: DocumentSnapshot) => void,
  onFail: (err: FirestoreError) => void
) => {
  getCheckoutDocRef(quoteId, firebase).onSnapshot(onSnapshot, onFail);
};

export const updateCheckout = async <T>(
  quoteId: string,
  values: T,
  subcollections: Subcollection[],
  firebase: FirebaseClient
) => {
  const checkoutDocRef = getCheckoutDocRef(quoteId, firebase);

  await checkoutDocRef.set(injectDataOwner(values, firebase), { merge: true });
  return subcollections.map(subcollection =>
    checkoutDocRef
      .collection(subcollection.name)
      .doc(subcollection.id || quoteId)
      .set(injectDataOwner(subcollection.values, firebase), { merge: true })
  );
};
